import HelpIcon from "@mui/icons-material/Help";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Avatar,
  Badge,
  CircularProgress,
  FormControl,
  InputBase,
  ListItemIcon,
  Menu,
  MenuItem,
  Select,
  Stack,
  styled,
  Toolbar,
  Typography,
  Backdrop
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import buildIdlogo from "../../../assets/images/build_logo_header.png";
import {
  fetchClientEmployeeAppsLicensesDetails,
  normalizeClientEmployeeAppsLicensesResponse
} from "../../../client/utils/clientEmployeeAppsLicenses";

import ReferralModal from "../../common/ReferralModal";
import {
  clearCarpoolState,
  setCarpoolOptLoader,
  setCarpoolSwitchValue,
  setChatState,
  setLogindata,
  setLogout,
  setLicences,
  setOpenNotificationMenu,
  setSelectedClientdata,
  setShowExport,
  setShowReport,
  setSelectedAppPermissions
} from "../../../redux/actions/actions";
import "./Header.css";
import NotificationsMenu from "./NotificationMenu";
import ProfileMenu from "./ProfileMenu";
import DashboardTutorial from "../../tutorial/DashboardTutorial";
import { BIBlue, BIRed } from "../../../assets/helpers";
import SwipeDownIcon from "@mui/icons-material/SwipeDown";
import ReportIcon from "@mui/icons-material/Report";
import { Search as SearchIcon } from "@mui/icons-material";
import SitesTutorial from "../../tutorial/SitesTutorial";
import CarpoolTutorial from "../../tutorial/CarpoolTutorial";
import JobpostingTutorial from "../../tutorial/JobpostingTutorial";
import ResumeBuilderTutorial from "../../tutorial/ResumeBuilderTutorial";
import TicketsTutorial from "../../tutorial/TicketsTutorial";
import ContentSearchTutorial from "../../tutorial/ContentSearchTutorial";
import MontageTutorial from "../../tutorial/MontageTutorial";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import {
  CHANGE_RIDE_SHARE_FOR_USER,
  /* FETCH_CLIENTS_EMPLOYEES, */ CLIENT_USE_LICENSES,
  CLIENT_DETAILS_BY_USERID,
  LOGOUT,
  MOVE_CHAT_GROUP_MESSAGES_UNREAD_TO_READ
} from "../../../constant/Apipath";
// import { BuildIdEventListener } from "../../../common/BuildIdEvent";
import _, { replace } from "lodash";
import { English } from "../../../constant/EnglishFallback";
import MyPostingTutorial from "../../tutorial/MyPostingTutorial";
import ShareResumeBuilder from "../../tutorial/ShareResumeBuilder";
import CloseIcon from "@mui/icons-material/Close";
import { Postrequestcall } from "../../../request/Postrequest";
import { Getrequestcall } from "../../../request/Getrequest";
import { getClientList } from "../../login/userService";
import ClientInvitation from "../../../client/invitation/ClientInvitation";
import SurveyModal from "../../survey/SurveyModal";
import BuildIdEvent, { BuildIdEventListener } from "../../../common/BuildIdEvent";
import SignalR from "../../../common/SignalR";
import { HubConnectionState } from "@microsoft/signalr";
import { setChatCount } from "../../../redux/actions/actions";
import { clearIndexDB } from "../../../db";

const TAG = "Header";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "white",
  color: "#8D8D8D",
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto"
  }
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      height: "19px"
    }
  }
}));

//fix
export default function Header({ setMobileOpen, loading }) {
  const isMountedRef = useRef(true);
  const abortControllerRef = useRef(null);

  const {
    loginData,
    selectedClientData,
    miannotification,
    multiLanguageData,
    unreadMsgCount,
    carpoolOptLoader,
    selectedChat = {},
    openNotificationMenu
  } = useSelector((state) => state?.main);
  const [currentClient, setCurrentClient] = useState("");
  const [menuView, setMenView] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [notificationMenuView, setNotificationMenuView] = useState(false);
  const [notificationAnchorEL, setNotificationAnchorEL] = useState(null);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const topbarLocation = useLocation();
  const pathname = topbarLocation?.pathname;
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [tutorialIndex, setTutorialIndex] = useState("");
  const [tutorialType, setTutorialType] = useState(null);
  const moreRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");

  const {
    TEXT_MASSAGE = English.BuilderNetwork.TEXT_MASSAGE,
    TEXT_COPY_LINK = English.BuilderNetwork.TEXT_COPY_LINK
  } = multiLanguageData?.BuilderNetwork || {};

  const {
    TEXT_SEARCH_BUILDID_PLACEHOLDER = English.Header.TEXT_SEARCH_BUILDID_PLACEHOLDER,
    TEXT_CHAT = English.Header.TEXT_CHAT,
    TEXT_NOTIFICATIONS = English.Header.TEXT_NOTIFICATIONS,
    TOP_BAR_MENU_HELP_CENTER = English.Header.TOP_BAR_MENU_HELP_CENTER,
    TEXT_MORE_MODAL_TUTORIAL = English.Header.TEXT_MORE_MODAL_TUTORIAL,
    BUTTON_REPORT = English.Header.BUTTON_REPORT
  } = multiLanguageData?.Header || {};
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const { TEXT_EXPORT_GOALS_SUMMARY = English.TimeSheet.TEXT_EXPORT_GOALS_SUMMARY } =
    LanguageData || {};

  useEffect(() => {
    abortControllerRef.current = new AbortController();
    return () => {
      isMountedRef.current = false;
      // Cancel any pending API calls
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    if (openNotificationMenu) {
      setNotificationAnchorEL(moreRef.current);
      setNotificationMenuView(true);
      dispatch(setOpenNotificationMenu(false));
    }
  }, [openNotificationMenu]);

  useEffect(() => {
    if (!loginData) {
      return;
    }
  }, [loginData?.accessToken]);

  useEffect(() => {
    if (selectedClientData?.OrganizationName) {
      setCurrentClient(selectedClientData?.OrganizationName);
    } else {
      dispatch(setSelectedClientdata({}));
      dispatch(setSelectedAppPermissions([]));
    }
  }, []);

  useEffect(() => {
    if (pathname !== "/content-search") {
      setSearchTerm(""); // Clear search on path change
    }
  }, [pathname]);

  const handleCurrentClientChange = async (e, name, skipApi = false) => {
    let selectedClientName;
    if (typeof name === "string") {
      selectedClientName = name;
    } else if (typeof e === "string") {
      selectedClientName = e;
    } else if (e?.target?.value) {
      selectedClientName = e.target.value;
    } else {
      selectedClientName = e; // Fallback to original behavior or maybe log warning
    }

    setCurrentClient(selectedClientName);

    if (loginData?.userInformation?.ClientsList?.length > 0) {
      const filteredClients = loginData?.userInformation?.ClientsList.filter(
        (client) => client.OrganizationName === selectedClientName
      );

      if (filteredClients.length > 0) {
        let client = filteredClients[0];
        // Call License Usage API
        if (client.OrganizationName !== "BuildID Free") {
          try {
            const payload = {
              ClientId: client.ClientId,
              UserId: client.UserId,
              ClientEmployeeId: client.ClientEmployeeId || client.Id,
              LicenseTypeId: client.Licenses?.[0]?.LicenseTypeId
            };
            await Postrequestcall(CLIENT_USE_LICENSES, payload, loginData?.accessToken);
            const clientAppsLicensesResponse = await fetchClientEmployeeAppsLicensesDetails(
              client.ClientId,
              client.ClientEmployeeId || client.Id,
              loginData?.accessToken
            );
            dispatch(
              setLicences(
                normalizeClientEmployeeAppsLicensesResponse(
                  clientAppsLicensesResponse?.response ?? clientAppsLicensesResponse
                )
              )
            );
          } catch (error) {
            console.error("Error calling CLIENT_USE_LICENSES", error);
          }
        } else {
          // console.log("Skipping CLIENT_USE_LICENSES for", client.OrganizationName, "skipApi:", skipApi);
        }
        let data = setSelectedClientdata(client);

        if (!data?.payload?.hasOwnProperty("AccentColor")) {
          data.payload.AccentColor = "#B73F3A";
        }
        if (data?.payload?.AccentColor == "") {
          data.payload.AccentColor = "#B73F3A";
        }
        if (!data?.payload?.hasOwnProperty("OrganizationName")) {
          // data.payload.OrganizationName = "BuildId";
          data.payload.OrganizationName = "BuildID Free";
        }
        dispatch(data);
      } else {
        dispatch(setSelectedClientdata({}));
        dispatch(setSelectedAppPermissions([]));
      }
    }
  };

  const handleClientActive = (id, ClientEmployeeId) => {
    if (id === 0) return;
    // Postrequestcall(UPDATE_CLIENT_EMPLOYEES_INFO, { Id: ClientEmployeeId }, loginData?.accessToken);
    navigate(`/client/${id}/home`);
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const onLogout = async (e, clientName) => {
    // Cancel any pending API calls
    setMenView(false);
    setAnchorEl(null);
    const deviceId = loginData?.userInformation?.DeviceId;
    setIsLoggingOut(true);
    try {
      if (pathname === "/chat") {
        if (selectedChat?.chatGroupId) {
          const newPayload = {
            UserId: loginData?.userInformation?.UserId,
            ChatGroupId: selectedChat?.chatGroupId,
            LastKnownMessageId: 0 // Reset to 0 for new chat
          };
          await Postrequestcall(
            MOVE_CHAT_GROUP_MESSAGES_UNREAD_TO_READ,
            newPayload,
            loginData?.accessToken
          );
        }
      }
      let getLoginresponse = await Getrequestcall(`${LOGOUT}/${deviceId}`, loginData?.accessToken);
      if (getLoginresponse?.status === 200) {
        if (pathname.includes("user-tickets")) {
          sessionStorage.setItem("logoutClicked", "true");
          sessionStorage.removeItem("userTicketId");
        } else {
          sessionStorage.removeItem("userTicketId");
          sessionStorage.removeItem("logoutClicked");
        }
        isMountedRef.current = false;
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
        }
        localStorage.setItem("ShowTradeModal", false);
        clearIndexDB();
        await dispatch(setLogout());
        handleCurrentClientChange(e, clientName);
        navigate("/", { replace: true });
      } else {
        setIsLoggingOut(false);
        console.log("Unexpected API Status From Logout API ");
      }
    } catch (error) {
      setIsLoggingOut(false);
      sessionStorage.removeItem("userTicketId");
      sessionStorage.removeItem("logoutClicked");
      console.log("Something Weng Wrong While Logging Out :", error);
    }
  };

  const navigateToChat = () => {
    navigate("/chat");
  };

  const onProfile = () => {
    dispatch(setSelectedClientdata({}));
    dispatch(setSelectedAppPermissions([]));
    setMenView(false);
    navigate("/" + loginData?.userInformation?.UserId);
  };

  const onEarnbuilderBucks = () => {
    setMenView(false);
    navigate("/reward-store/earn-builderbucks");
  };

  const handleClick = async (event, isFor, from) => {
    if (from === "formMenu" && isFor === "notification") {
      setNotificationAnchorEL(moreRef.current);
      setNotificationMenuView((prev) => !prev);
      return;
    }
    if (isFor === "notification") {
      setNotificationAnchorEL(event?.currentTarget);
      setNotificationMenuView((prev) => !prev);
    } else {
      setAnchorEl(event?.currentTarget);
      setMenView((prev) => !prev);
      if (isMountedRef.current && loginData?.accessToken) {
        await getUpdatedClientlist();
      }
    }
  };

  const getUpdatedClientlist = async () => {
    try {
      let responseClientList = [];
      try {
        const detailPayload = {
          UserId: Number(loginData?.userInformation?.UserId),
          UserEmail: loginData?.userInformation?.Email
        };
        const detailRes = await Postrequestcall(
          CLIENT_DETAILS_BY_USERID,
          detailPayload,
          loginData?.accessToken
        );
        // Based on user image, Data contains ClientsList
        responseClientList = detailRes?.data?.Data?.ClientsList || [];
        // Capture invites
        var pendingInvitations = detailRes?.data?.Data?.ClientInvitation || [];
      } catch (error) {
        console.log("CLIENT_DETAILS_BY_USERID Error:", error);
      }

      const capitalizedClientList = getClientList(responseClientList);
      let getObj = {
        ...loginData,
        userInformation: {
          ...loginData.userInformation,
          ClientsList: capitalizedClientList,
          PendingInvitations: pendingInvitations || []
        }
      };
      if (
        isMountedRef.current &&
        loginData?.accessToken &&
        !abortControllerRef.current?.signal?.aborted
      ) {
        dispatch(setLogindata(getObj));
      }
    } catch (error) {}
  };

  const [showInvitation, setShowinvitation] = useState(false);

  const handleViewInvite = (invite) => {
    // Update Redux with selected invitation so the modal can read it
    let updatedLoginData = {
      ...loginData,
      userInformation: {
        ...loginData.userInformation,
        ClientInvitation: {
          ...invite,
          // ClientId: invite.ClientId,
          Status: 1
        }
      }
    };
    dispatch(setLogindata(updatedLoginData));
    setShowinvitation(true);
  };

  const showReportBtn = () => {
    if (
      pathname === "/community" ||
      pathname === "/home" ||
      pathname === "/companies" ||
      pathname === "/manufactures" ||
      pathname === "/reward-store" ||
      pathname === "/products" ||
      pathname === "/trades" ||
      pathname === "/sites" ||
      pathname === "/montages" ||
      pathname === "/tickets" ||
      pathname === "/timesheets" ||
      pathname === "/chat" ||
      pathname === "/expenses" ||
      pathname === "/contacts" ||
      pathname === "/buy-sell" ||
      pathname === "/buy-sell/my-listing" ||
      pathname === "/job-postings" ||
      pathname === "/carpool" ||
      pathname === "/resume-builder" ||
      pathname === "/content-search" ||
      pathname === "/reward-store/" ||
      pathname === "/rewards/earn-builderbucks/" ||
      pathname === "/rewards/account-activity/" ||
      pathname === "/montages/add" ||
      pathname === "/rewards/earn-rewards" ||
      pathname.includes("/company") ||
      pathname.includes("/manufacture") ||
      pathname.includes("/product") ||
      pathname.includes("/trade")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const showTutorialBtn = () => {
    const tutorialPaths = [
      "/community",
      "/sites",
      "/montages/add",
      "/tickets",
      "/job-postings",
      "/job-postings/my-postings",
      "/ShareResumeBuilder",
      "/carpool",
      "/resume-builder",
      "/content-search"
    ];

    // Handle dynamic route separately
    if (pathname.startsWith("/montages/edit/")) {
      return true;
    }

    return tutorialPaths.includes(pathname);
  };

  const onTutorialClick = () => {
    setMoreMenuAnchorEl(null);

    if (pathname === "/community") {
      setTutorialIndex(1);
      return setTutorialType("CommunityHome");
    }
    if (pathname === "/sites") {
      setTutorialIndex(1);
      return setTutorialType("sites");
    }
    if (pathname === "/montages/add") {
      setTutorialIndex(1);
      return setTutorialType("montages");
    }
    if (pathname === "/tickets") {
      setTutorialIndex(1);
      return setTutorialType("ticket");
    }
    if (pathname === "/job-postings") {
      setTutorialIndex(1);
      return setTutorialType("job-postings");
    }
    if (pathname === "/job-postings/my-postings") {
      setTutorialIndex(1);
      return setTutorialType("my-postings");
    }
    if (pathname === "/resume-builder/add-resume") {
      setTutorialIndex(1);
      return setTutorialType("share-resume-builder");
    }
    if (pathname === "/carpool") {
      setTutorialIndex(1);
      return setTutorialType("carpool");
    }
    if (pathname === "/resume-builder") {
      setTutorialIndex(1);
      return setTutorialType("resume-builder");
    }
    if (pathname === "/content-search") {
      setTutorialIndex(1);
      return setTutorialType("content-search");
    }
    setTutorialIndex(0);
    return setTutorialType(null);
  };

  const handleReferClick = () => {
    setShowInviteModal(true);
    // setMoreMenuAnchorEl(null);
  };
  const onReportClick = () => {
    let repostName = "";
    if (pathname === "/home") {
      repostName = "Dashboard";
    } else if (pathname === "/community") {
      repostName = "post";
    } else if (pathname === "/sites") {
      repostName = "sites";
    } else if (pathname === "/montages") {
      repostName = "montages";
    } else if (pathname === "/tickets") {
      repostName = "ticket";
    } else if (pathname === "/job-postings") {
      repostName = "job-postings";
    } else if (pathname === "/job-postings/my-postings") {
      repostName = "my-postings";
    } else if (pathname === "/carpool") {
      repostName = "carpool";
    } else if (pathname === "/resume-builder") {
      repostName = "resume-builder";
    } else if (pathname === "/content-search") {
      repostName = "content-search";
    } else if (pathname === "/timesheets") {
      repostName = "timesheets";
    } else if (pathname === "/expenses") {
      repostName = "expenses";
    } else if (pathname === "/reward-store/") {
      repostName = "store";
    } else if (pathname === "/rewards/earn-builderbucks/") {
      repostName = "earn-builderbucks";
    } else if (pathname === "/rewards/account-activity/") {
      repostName = "account-activity";
    } else if (pathname === "/rewards/earn-rewards") {
      repostName = "earn-rewards";
    } else if (pathname === "/buy-sell") {
      repostName = "buy-sell";
    } else if (pathname === "/buy-sell/my-listing") {
      repostName = "buy-sell";
    } else if (pathname === "/chat") {
      repostName = "chat";
    } else if (pathname === "/contacts") {
      repostName = "Builder Network";
    }
    setMoreMenuAnchorEl(false);
    let reportObj = {
      showReport: true,
      name: repostName,
      recordId: repostName == "earn-rewards" ? Number(localStorage?.quizQuestionId) : 0
    };
    dispatch(setShowReport(reportObj));
  };

  const onOptCarpoolClick = async () => {
    setMoreMenuAnchorEl(null);
    dispatch(
      setCarpoolOptLoader({
        isLoading: true,
        optedFlag: "Join Carpool"
      })
    );
    try {
      const getObj = {
        UserId: loginData?.userInformation?.UserId,
        RideShareInterested: false
      };
      await Postrequestcall(CHANGE_RIDE_SHARE_FOR_USER, getObj, loginData?.accessToken);
      dispatch(clearCarpoolState());
      dispatch(
        setCarpoolOptLoader({
          isLoading: false,
          optedFlag: "Opt Out Carpool"
        })
      );
    } catch (error) {
      dispatch(
        setCarpoolOptLoader({
          isLoading: false,
          optedFlag: "Join Carpool"
        })
      );
    }
  };

  const onSearchSubmit = () => {
    navigate("/content-search", {
      state: {
        searchTerm
      }
    });
  };

  return (
    <>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Stack gap={1} flexDirection={"row"} alignItems={"center"}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { sm: "none" } }}>
            <MenuIcon />
          </IconButton>
          <img className="responsive-buildid-logo" src={buildIdlogo} alt="no data" />

          <Search
            sx={{ margin: 0 }}
            className="search-buildid"
            onKeyDown={(e) => {
              e?.key === "Enter" && onSearchSubmit();
            }}>
            <SearchIconWrapper>
              <SearchIcon color="#cccccc " />
            </SearchIconWrapper>
            <StyledInputBase
              value={searchTerm}
              placeholder={TEXT_SEARCH_BUILDID_PLACEHOLDER}
              inputProps={{ "aria-label": "search" }}
              onChange={(e) => setSearchTerm(e?.target?.value)}
              size="small"
            />

            {searchTerm && (
              <IconButton
                size="small"
                onClick={() => setSearchTerm("")}
                sx={{
                  position: "absolute",
                  right: 0,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "inherit",
                  padding: "6px",
                  backgroundColor: "white",
                  "&:hover": {
                    backgroundColor: "white" // maintain white background
                  }
                }}
                aria-label="clear search">
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
          </Search>
        </Stack>
        <Stack
          gap={1}
          sx={{
            flexDirection: "row",
            display: {
              xs: "flex",
              sm: "flex",
              md: "none",
              lg: "none",
              xl: "none"
            }
          }}>
          <Avatar
            onClick={(e) => handleClick(e)}
            alt="Remy Sharp"
            style={{ height: "35px", width: "35px", cursor: "pointer" }}
            src={loginData?.pictureUrl}
          />
          {showReportBtn() && (
            <IconButton size="small" onClick={(event) => setMoreMenuAnchorEl(event.currentTarget)}>
              <MoreVertIcon />
            </IconButton>
          )}
        </Stack>

        <Stack
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "flex",
              lg: "flex",
              xl: "flex"
            }
          }}
          flexDirection={"row"}
          alignItems={"center"}
          gap={1}>
          <Stack
            flexDirection={"row"}
            sx={{
              display: {
                xs: "none",
                sm: "none ",
                md: "flex",
                lg: "flex",
                xl: "flex"
              }
            }}>
            {loading ? (
              <CircularProgress size={24} style={{ color: "#083db8", marginRight: "10px" }} />
            ) : (
              <IconButton
                size="small"
                color="inherit"
                style={{ color: "#083db8", marginRight: "10px" }}
                onClick={() => navigateToChat()}>
                <Badge
                  badgeContent={
                    Number.isFinite(Number(unreadMsgCount)) ? Number(unreadMsgCount) : 0
                  }
                  color="error">
                  <QuestionAnswerIcon fontSize="medium" />
                </Badge>
                <span className="chat-notification"></span>
              </IconButton>
            )}
          </Stack>

          <IconButton
            size="small"
            color="inherit"
            style={{ color: "#083db8", marginRight: "10px" }}
            onClick={(e) => handleClick(e, "notification")}>
            {miannotification > 0 ? (
              <Badge color="error" variant="dot" overlap="circular" size="small">
                <NotificationsIcon fontSize="medium" />
              </Badge>
            ) : (
              <NotificationsIcon fontSize="medium" />
            )}
          </IconButton>

          <Avatar
            onClick={(e) => handleClick(e)}
            alt="Remy Sharp"
            style={{ height: "35px", width: "35px", cursor: "pointer" }}
            src={loginData?.pictureUrl}
          />
          <IconButton
            ref={moreRef}
            size="small"
            onClick={(event) => setMoreMenuAnchorEl(event.currentTarget)}>
            <MoreVertIcon />
          </IconButton>

          <Menu
            anchorEl={moreMenuAnchorEl}
            open={Boolean(moreMenuAnchorEl)}
            onClose={() => setMoreMenuAnchorEl(null)}
            anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            sx={{
              "& .MuiPaper-root": {
                borderRadius: "10px",
                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
                marginTop: "10px"
              }
            }}>
            <Stack
              sx={{
                display: {
                  xs: "flex",
                  sm: "flex",
                  md: "none",
                  lg: "none",
                  xl: "none"
                }
              }}>
              <Stack padding={" 5px 10px "}>
                {loginData?.userInformation?.ClientsList?.length > 0 && (
                  <>
                    {selectedClientData !== "" && (
                      <FormControl
                        sx={{
                          display: "flex",
                          "& fieldset": { display: "none" },
                          background: "white",
                          borderRadius: "4px"
                        }}>
                        <Select
                          labelId="orglabel-id"
                          value={
                            currentClient === undefined
                              ? loginData?.userInformation?.ClientsList[0].OrganizationName
                              : currentClient
                          }
                          onSelect={handleCurrentClientChange}
                          onChange={handleCurrentClientChange}
                          sx={{
                            "& .MuiSelect-select": {
                              display: "flex",
                              maxWidth: "200px",

                              alignItems: "center",
                              gap: "10px",
                              padding: "5px"
                            }
                          }}>
                          {loginData?.userInformation?.ClientsList.map((client) => (
                            <MenuItem
                              dense
                              key={client.ClientId}
                              value={client.OrganizationName}
                              style={{
                                display: "flex",
                                gap: "10px"
                              }}
                              onClick={() => handleClientActive(client.ClientId)}>
                              <Avatar
                                alt={client.OrganizationName}
                                style={{ height: "25px", width: "25px" }}
                                src={client.ClientLogo}
                              />
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  maxWidth: "130px",
                                  wordBreak: "break-all",
                                  display: "-webkit-box",
                                  overflow: "hidden",
                                  WebkitBoxOrient: "vertical"
                                }}>
                                {client.OrganizationName}
                              </Typography>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </>
                )}
              </Stack>
              <MenuItem
                onClick={(e) => {
                  navigateToChat();
                  setMoreMenuAnchorEl(null);
                }}
                dense>
                <ListItemIcon size="small" color="inherit">
                  <QuestionAnswerIcon sx={{ color: BIBlue }} fontSize="medium" />
                  <span className="chat-notification"></span>
                </ListItemIcon>
                <Typography>{TEXT_CHAT}</Typography>
              </MenuItem>
              <MenuItem
                onClick={(e) => {
                  handleClick(e, "notification", "formMenu");
                  setMoreMenuAnchorEl(null);
                }}
                dense>
                <ListItemIcon size="small" color="inherit">
                  {miannotification > 0 ? (
                    <Badge color="error" variant="dot" overlap="circular" size="small">
                      <NotificationsIcon fontSize="medium" />
                    </Badge>
                  ) : (
                    <NotificationsIcon fontSize="medium" />
                  )}
                </ListItemIcon>
                <Typography>{TEXT_NOTIFICATIONS}</Typography>
              </MenuItem>
            </Stack>
            <MenuItem
              dense
              onClick={() => {
                setMoreMenuAnchorEl(null);
                window.open("https://mybuilderid.com/faqapp", "_blank");
              }}
              target="_blank">
              <ListItemIcon>
                <HelpIcon
                  sx={{
                    color: BIBlue,
                    height: "25px",
                    width: "25px"
                  }}
                />
              </ListItemIcon>
              <Typography fontSize={"14px"}>{TOP_BAR_MENU_HELP_CENTER}</Typography>
            </MenuItem>
            {showTutorialBtn() && (
              <MenuItem dense onClick={onTutorialClick}>
                <ListItemIcon>
                  <SwipeDownIcon
                    sx={{
                      color: BIBlue,
                      height: "25px",
                      width: "25px"
                    }}
                  />
                </ListItemIcon>
                <Typography fontSize={"14px"}>{TEXT_MORE_MODAL_TUTORIAL}</Typography>
              </MenuItem>
            )}
            {pathname === "/timesheets" && (
              <MenuItem
                dense
                onClick={() => {
                  dispatch(setShowExport(true));
                  setMoreMenuAnchorEl(false);
                }}>
                <ListItemIcon>
                  <ImportExportIcon
                    sx={{
                      color: BIBlue,
                      height: "25px",
                      width: "25px"
                    }}
                  />
                </ListItemIcon>
                <Typography fontSize={"14px"}>{TEXT_EXPORT_GOALS_SUMMARY}</Typography>
              </MenuItem>
            )}
            {!(
              /^\/[0-9]+$/.test(pathname) ||
              pathname === "/companies" ||
              pathname === "/manufactures" ||
              pathname === "/products" ||
              pathname === "/trades"
            ) && (
              <MenuItem dense onClick={onReportClick} style={{ color: BIRed }}>
                <ListItemIcon>
                  <ReportIcon sx={{ color: BIBlue, height: "25px", width: "25px" }} />
                </ListItemIcon>
                <Typography fontSize={"14px"} color={BIRed}>
                  {BUTTON_REPORT}
                </Typography>
              </MenuItem>
            )}
            {pathname === "/carpool" && (
              <MenuItem dense onClick={onOptCarpoolClick} style={{ color: BIRed }}>
                {/* <ListItemIcon>
                  <ReportIcon sx={{ color: BIBlue, height: "25px", width: "25px" }} />
                </ListItemIcon> */}
                <Typography fontSize={"14px"} color={BIRed}>
                  {"Opt out of carpooling"}
                </Typography>
              </MenuItem>
            )}
          </Menu>
          <ReferralModal
            open={showInviteModal}
            from={"home"}
            TEXT_MASSAGE={TEXT_MASSAGE}
            TEXT_COPY_LINK={TEXT_COPY_LINK}
            onClose={() => {
              setShowInviteModal(false);
            }}
          />
        </Stack>
        <ProfileMenu
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          onLogout={onLogout}
          menuView={menuView}
          setMenView={setMenView}
          onProfile={onProfile}
          handleReferClick={handleReferClick}
          onEarnbuilderBucks={onEarnbuilderBucks}
          handleCurrentClientChange={handleCurrentClientChange}
          handleClientActive={handleClientActive}
          selectedClientData={selectedClientData}
          handleViewInvite={handleViewInvite}
        />

        <NotificationsMenu
          anchorEl={notificationAnchorEL}
          setAnchorEl={setNotificationAnchorEL}
          menuView={notificationMenuView}
          setMenView={setNotificationMenuView}
        />
      </Toolbar>
      {showInvitation && (
        <ClientInvitation
          showInvitation={showInvitation}
          getData={async () => {
            await getUpdatedClientlist();
          }}
          handleClose={() => {
            setShowinvitation(false);
          }}
        />
      )}

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          flexDirection: "column"
        }}
        open={isLoggingOut}>
        <CircularProgress color="inherit" />
        <Typography sx={{ mt: 2, fontSize: "16px" }}>Logging you out, please wait</Typography>
      </Backdrop>

      {tutorialType === "CommunityHome" ? (
        <DashboardTutorial
          onPress={() => {
            setTutorialIndex((p) => (p >= 3 ? 0 : p + 1));
          }}
          tutorialIndex={tutorialIndex}
        />
      ) : tutorialType === "sites" ? (
        <SitesTutorial
          onPress={() => {
            setTutorialIndex((p) => (p >= 5 ? 0 : p + 1));
          }}
          tutorialIndex={tutorialIndex}
        />
      ) : tutorialType === "carpool" ? (
        <CarpoolTutorial
          onPress={() => {
            setTutorialIndex((p) => (p >= 4 ? 0 : p + 1));
          }}
          tutorialIndex={tutorialIndex}
        />
      ) : tutorialType === "job-postings" ? (
        <JobpostingTutorial
          onPress={() => {
            setTutorialIndex((p) => (p >= 2 ? 0 : p + 1));
          }}
          tutorialIndex={tutorialIndex}
        />
      ) : tutorialType === "my-postings" ? (
        <MyPostingTutorial
          onPress={() => {
            setTutorialIndex((p) => (p >= 1 ? 0 : p + 1));
          }}
          tutorialIndex={tutorialIndex}
        />
      ) : tutorialType === "share-resume-builder" ? (
        <ShareResumeBuilder
          onPress={() => {
            setTutorialIndex((p) => (p >= 1 ? 0 : p + 1));
          }}
          tutorialIndex={tutorialIndex}
        />
      ) : tutorialType === "resume-builder" ? (
        <ResumeBuilderTutorial
          onPress={() => {
            setTutorialIndex((p) => (p >= 2 ? 0 : p + 1));
          }}
          tutorialIndex={tutorialIndex}
        />
      ) : tutorialType === "ticket" ? (
        <TicketsTutorial
          onPress={() => {
            setTutorialIndex((p) => (p >= 4 ? 0 : p + 1));
          }}
          tutorialIndex={tutorialIndex}
        />
      ) : tutorialType === "content-search" ? (
        <ContentSearchTutorial
          onPress={() => {
            setTutorialIndex((p) => (p >= 3 ? 0 : p + 1));
          }}
          tutorialIndex={tutorialIndex}
        />
      ) : tutorialType === "montages" ? (
        <MontageTutorial
          onPress={() => {
            setTutorialIndex((p) => (p >= 6 ? 0 : p + 1));
          }}
          tutorialIndex={tutorialIndex}
        />
      ) : null}
    </>
  );
}
